import { fetch } from '../utils/request';

const { BOARDS_BASE } = require('./services');

const getUrl = (path) => `${BOARDS_BASE}${path}`;

export default {
  getBoards(owner) {
    return fetch(getUrl(`/tagboards/${owner}`));
  },
};
